/*eslint-disable*/
import React, { useEffect } from "react";
import {
    Card,
    CardBody,
    Label,
    FormGroup,
    Row,
    Input,
    Container,
    CardHeader,
    CardFooter,
    Button,
    Form
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import axios from 'axios';
import SimpleHeader from "components/Headers/SimpleHeader.js";

export default function EditBank(props) {
    const [updateBank, setUpdateBank] = React.useState([]);
    let history = useHistory();

    const handleChange = (event) => {
        setUpdateBank({ ...updateBank, [event.target.name]: event.target.value })
    }

    useEffect(() => {
        getBankById();
    }, []);

    const getBankById = () => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/bank/${props.match.params.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(),
        })
            .then(response => response.json())
            .then(data => {
                const responseData = data.response_data;
                setUpdateBank({
                    bank_code: responseData.bank_code,
                    bank_name: responseData.bank_name,
                    clearing_code: responseData.clearing_code
                })

            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    function UpdateDataBank() {
        let data = updateBank
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/bank/update/${props.match.params.id}`, data)
            .then(function (response) {
                history.push("/admin/bank");
            })
            .catch(function (error) {
                console.log(error)
            })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        UpdateDataBank();
    }
    return (
        <>
            <SimpleHeader name="Edit Bank" parentName="Admin" />
            <Container className="mt--6" fluid>
                <Row>
                    <div className="col">
                        <Card>
                            <CardBody>
                                <Form onSubmit={handleSubmit} >
                                    <CardHeader>
                                        <h3>Edit Bank</h3>
                                    </CardHeader>
                                    <CardBody>
                                        <FormGroup>
                                            <Label
                                                className="form-control-label"
                                                htmlFor="serial_number"
                                            >
                                                Bank Code
                                            </Label>
                                            <Input
                                                type="text"
                                                name="bank_code"
                                                placeholder="Masukan Bank Code"
                                                value={updateBank.bank_code}
                                                onChange={handleChange}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label
                                                className="form-control-label"
                                                htmlFor="exampleFormControlInput1"
                                            >
                                                Bank Name
                                            </Label>
                                            <Input
                                                type="text"
                                                name="bank_name"
                                                placeholder="Masukan Bank Name"
                                                value={updateBank.bank_name}
                                                onChange={handleChange}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label
                                                className="form-control-label"
                                                htmlFor="exampleFormControlInput1"
                                            >
                                                Clearing Code
                                            </Label>
                                            <Input
                                                type="text"
                                                name="clearing_code"
                                                placeholder="Masukan Clearing Code"
                                                value={updateBank.clearing_code}
                                                onChange={handleChange}
                                            />
                                        </FormGroup>
                                    </CardBody>
                                    <CardFooter>
                                        <Button color="primary" type="submit">
                                            Ubah
                                        </Button>
                                        <Link class="btn btn-info" to="/admin/bank">
                                            Kembali
                                        </Link>
                                    </CardFooter>
                                </Form>
                            </CardBody>
                        </Card>
                    </div>
                </Row>
            </Container>
        </>
    );
}
